<template>

  <!-- Table Container Card -->
  <b-card
    no-body
  >

    <div class="m-2">

      <!-- Table Top -->
      <b-row>

        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <v-select
            v-model="perPage"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block ml-50 mr-1"
          />
          <b-button
            v-if="$can('manage', 'All')"
            v-b-toggle.sidebar-create-quote-distribution
            variant="primary"
          >
            {{ $t('Distribution') }}
          </b-button>
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              v-model="searchQuery"
              class="d-inline-block mr-1"
              :placeholder="$t('Search')"
            />
          </div>
        </b-col>
      </b-row>

    </div>

    <b-table
      ref="quoteDistributionTable"
      :items="list"
      responsive
      :fields="tableColumns"
      primary-key="id"
      :sort-by.sync="sortBy"
      show-empty
      :empty-text="$t('No matching records found')"
      :sort-desc.sync="isSortDirDesc"
      :busy="isBusy"
      class="position-relative"
    >
      <template #head()="data">
        {{ $t(data.label) }}
      </template>

      <template #cell(index)="data">
        {{ data.index + 1 }}
      </template>

      <template #cell(from_org)="data">
        {{ $langName(data.value.name) }}
      </template>

      <template #cell(period)="data">
        {{ data.value.admission_year + '-' + data.value.name }}
      </template>

      <template #cell(status)="data">
        <b-badge :variant="getQuoteDistributionStatusColor(data.value)">
          {{ $langName(getQuoteDistributionStatus(data.value).name) }}
        </b-badge>
      </template>
      <template #cell(total_quote_type)="data">
        <b-badge :variant="getQuoteDistributionStatusColor(data.value)">
          {{ $langName(getTotalQuoteTypeStatus(data.value).name) }}
        </b-badge>
      </template>

      <template #cell(file)="data">
        <FileDownloadComponent :href="data.value" />
      </template>
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner
            variant="primary"
            label=""
          />
        </div>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">

        <div class="text-nowrap">
          <feather-icon
            icon="EyeIcon"
            class="cursor-pointer mr-1"
            size="16"
            @click="$router.push({ name: 'quote-distribution-view', params: { id: data.item.id }})"
          />
          <b-dropdown
            v-if="isOwnQuoteDistribution(data.item)"
            variant="link"
            toggle-class="text-decoration-none"
            no-caret
          >
            <template #button-content>
              <b-icon icon="file-earmark-excel" />
            </template>
            <b-dropdown-item @click="exportExcel(data.item.period.id)">
              {{ $t('Excel 1') }}
            </b-dropdown-item>
            <b-dropdown-item @click="exportExcelApplyDoc(data.item.period.id)">
              {{ $t('Excel 2') }}
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>

    </b-table>
    <div class="mx-2 mb-2">
      <b-row>
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">{{ $t("table summary", { from: dataMeta.from, to: dataMeta.to, of: dataMeta.of }) }} </span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >

          <b-pagination
            v-model="currentPage"
            :total-rows="total"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>
      </b-row>
      <create
        ref="createQuoteDistribution"
        @refetchData="refetchData"
      />
    </div>
  </b-card>

</template>

<script>
import {
  BButton, BCard, BCol, BFormInput, BPagination, BRow, BSpinner,
  BTable, VBToggle, BBadge, BIcon, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { onUnmounted } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import FileDownloadComponent from '@/views/components/FileDownloadComponent.vue'
import store from '@/store'
import config from './config'
import quoteDistributionModule from '@/store/quote-distribution/index'
import periodModule from '@/store/period/index'
import Create from './Create.vue'
import { myOrganization } from '@/auth/utils'
import statisticModule from '@/store/statistic'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    FileDownloadComponent,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    vSelect,
    BSpinner,
    Create,
    BBadge,
    BIcon,
    BDropdown,
    BDropdownItem,
  },
  created() {
    this.$store.commit(`${this.MODULE_NAME}/FRESH`)
    // this.$store.dispatch('staticModule/quoteDistributionTypes')
  },
  methods: {
    getQuoteDistributionType(id) {
      return this.$store.getters['staticModule/getQuoteDistributionType'](id)
    },
    getQuoteDistributionStatus(id) {
      return this.$store.getters['staticModule/getQuoteDistributionStatus'](id)
    },
    getTotalQuoteTypeStatus(id) {
      return this.$store.getters['staticModule/getTotalQuoteType'](id)
    },
    getQuoteDistributionStatusColor(id) {
      return this.$store.getters['staticModule/getQuoteDistributionStatusColor'](id)
    },
    isOwnQuoteDistribution(quoteDistribution) {
      return myOrganization() && quoteDistribution.from_org.id === myOrganization().id
    },
    exportExcel(periodId) {
      this.$store.dispatch(`${this.MODULE_STATISTIC}/distributedQuote`, periodId).then(res => {
        const link = document.createElement('a')
        link.href = res.data.path
        link.setAttribute('download', true)
        document.body.appendChild(link)
        link.click()
      }).catch(err => {
        this.$errorSwal(this, err)
      })
    },
    exportExcelApplyDoc(periodId) {
      this.$store.dispatch(`${this.MODULE_STATISTIC}/appliedDocAndLanguageCertificate`, periodId).then(res => {
        const link = document.createElement('a')
        link.href = res.data.path
        link.setAttribute('download', true)
        document.body.appendChild(link)
        link.click()
      }).catch(err => {
        this.$errorSwal(this, err)
      })
    },
  },
  setup() {
    const MODULE_NAME = 'quoteDistribution'
    const MODULE_PERIOD = 'period'
    const MODULE_STATISTIC = 'statistic'
    // Register module
    if (!store.hasModule(MODULE_NAME)) store.registerModule(MODULE_NAME, quoteDistributionModule)
    if (!store.hasModule(MODULE_PERIOD)) store.registerModule(MODULE_PERIOD, periodModule)
    if (!store.hasModule(MODULE_STATISTIC)) store.registerModule(MODULE_STATISTIC, statisticModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_NAME)) store.unregisterModule(MODULE_NAME)
      if (store.hasModule(MODULE_PERIOD)) store.unregisterModule(MODULE_PERIOD)
      if (store.hasModule(MODULE_STATISTIC)) store.unregisterModule(MODULE_STATISTIC)
    })

    return {
      ...config(),
      MODULE_NAME,
      MODULE_STATISTIC,
    }
  },
}
</script>

<style>
  .dropdown .btn-link {
    padding: 0;
  }
</style>
